// src/routes.js
import Dashboard from '@pages/Dashboard';
import Profile from '@pages/profile/Profile';
import Account from '@pages/account/Account';
import AccountAdd from '@pages/account/AccountAdd';
import AccountEdit from '@pages/account/AccountEdit';
import EmailConfig from '@pages/emailConfig/EmailConfig';
import EmailConfigAdd from '@pages/emailConfig/EmailConfigAdd';
import EmailConfigEdit from '@pages/emailConfig/EmailConfigEdit';
import LoginHistory from '@app/pages/report/countLogin/LoginHistory';
import StatisticLoginHistory from '@app/pages/report/countLogin/StatisticLoginHistory';
import Log from '@pages/log/Log';
import Timeline from '@pages/timeline/Timeline';
import ApiRoleMapping from '@app/pages/apiRoleMapping/ApiRoleMapping';
import ApiRoleMappingAdd from '@app/pages/apiRoleMapping/ApiRoleMappingAdd';
import ApiRoleMappingEdit from '@app/pages/apiRoleMapping/ApiRoleMappingEdit';

import {URI_INTERNAL} from './utils/pathLocations';
import OpeniddictApplication from '@app/pages/openiddictApplication/OpeniddictApplication';
import OpeniddictApplicationAdd from '@app/pages/openiddictApplication/OpeniddictApplicationAdd';
import OpeniddictApplicationEdit from '@app/pages/openiddictApplication/OpeniddictApplicationEdit';
import RoleAccount from '@app/pages/roleAccount/RoleAccount';
import RoleAccountAdd from '@app/pages/roleAccount/RoleAccountAdd';
import RoleAccountEdit from '@app/pages/roleAccount/RoleAccountEdit';
import Department from '@app/pages/department/Department';
import DepartmentAdd from '@app/pages/department/DepartmentAdd';
import DepartmentEdit from '@app/pages/department/DepartmentEdit';
import MaterialCatalog from '@app/pages/materialCatalog/MaterialCatalog';
import MaterialCatalogAdd from '@app/pages/materialCatalog/MaterialCatalogAdd';
import MaterialCatalogEdit from '@app/pages/materialCatalog/MaterialCatalogEdit';
import MaterialCatalogBulkImport from '@app/pages/materialCatalog/MaterialCatalogBulkImport';

import MaintenanceBatchList from '@app/pages/maintenanceEvent/MaintenanceBatchList';
import MaintenanceBatchAdd from '@app/pages/maintenanceEvent/MaintenanceBatchAdd';
import MaintenanceBatchDetail from '@app/pages/maintenanceEvent/MaintenanceBatchDetail';

import InventorySessionList from '@app/pages/inventorySession/InventorySessionList';
import InventorySessionCreate from '@app/pages/inventorySession/InventorySessionCreate';
import InventorySessionDetail from '@app/pages/inventorySession/InventorySessionDetail';
import AssetReport from '@app/pages/asset/AssetReport';

import AssetDisposalList from '@app/pages/assetDisposal/AssetDisposalList';
import AssetDisposalCreate from '@app/pages/assetDisposal/AssetDisposalCreate';
import AssetDisposalDetail from '@app/pages/assetDisposal/AssetDisposalDetail';
import AssetTransferList from '@app/pages/assetTransfer/AssetTransferList';
import AssetStatus from '@app/pages/assetStatus/AssetStatus';
import AssetStatusAdd from '@app/pages/assetStatus/AssetStatusAdd';
import AssetStatusEdit from '@app/pages/assetStatus/AssetStatusEdit';
import AssetGroup from '@app/pages/assetGroup/AssetGroup';
import AssetGroupAdd from '@app/pages/assetGroup/AssetGroupAdd';
import AssetGroupEdit from '@app/pages/assetGroup/AssetGroupEdit';
import Asset from '@app/pages/asset/Asset';
import AssetAdd from '@app/pages/asset/AssetAdd';
import AssetEdit from '@app/pages/asset/AssetEdit';
import AssetBulkImport from '@app/pages/asset/AssetBulkImport';
import AssetTransfer from '@app/pages/asset/AssetTransfer';
import AssetCategoryTabs from '@app/pages/assetCategory/AssetCategoryTabs';
import AssetPublicDetail from '@app/pages/asset/AssetPublicDetail';
import QRScanner from '@app/pages/asset/QRScanner';

const rawRoutes = [
    // dashboard
    {
        path: '/', // bạn có thể thêm HOME_PATH = '/'
        exact: true,
        component: Dashboard,
        isPublic: false,
        // label:      'Dashboard',
        controller: '',
        action: '',
        label: 'Dashboard',
        menu: true,
        isPublic: false
    },
    // profile
    {
        path: '/profile',
        exact: true,
        component: Profile,
        isPublic: false,
        // controller: 'Profile',
        // action:     'View',
        // label:      'Profile',
        controller: '',
        action: '',
        label: 'Thông tin cá nhân',
        menu: false,
        isPublic: false
    },
    // account
    {
        path: URI_INTERNAL.ACCOUNT_PATH,
        exact: true,
        component: Account,
        isPublic: false,
        controller: 'Account',
        // controller: '',
        action: '',
        label: 'Tài khoản',
        menu: true,
        icon: 'fas fa-user',
        isPublic: false
    },
    {
        path: URI_INTERNAL.ACCOUNT_PATH_ADD,
        exact: true,
        component: AccountAdd,
        isPublic: false,
        // controller: 'Account',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ACCOUNT_PATH_EDIT,
        exact: true,
        component: AccountEdit,
        isPublic: false,
        // controller: 'Account',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    //role
    {
        path: URI_INTERNAL.ROLE_ACCOUNT_PATH,
        exact: true,
        component: RoleAccount,
        isPublic: false,
        controller: 'Role',
        // controller: '',
        action: '',
        label: 'Quyền',
        menu: true,
        icon: 'fas fa-shield-alt',
        isPublic: false
    },
    {
        path: URI_INTERNAL.ROLE_ACCOUNT_CREATE_PATH,
        exact: true,
        component: RoleAccountAdd,
        isPublic: false,
        // controller: 'Account',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ROLE_ACCOUNT_EDIT_PATH,
        exact: true,
        component: RoleAccountEdit,
        isPublic: false,
        // controller: 'Account',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    // email config
    {
        path: URI_INTERNAL.EMAILCONFIG_PATH,
        exact: true,
        component: EmailConfig,
        isPublic: false,
        controller: 'EmailConfig',
        // controller: '',
        action: '',
        label: 'Email gửi thông báo',
        menu: true,
        icon: 'fas fa-envelope',
        isPublic: false
    },
    {
        path: URI_INTERNAL.EMAILCONFIG_CREATE_PATH,
        exact: true,
        component: EmailConfigAdd,
        isPublic: false,
        // controller: 'EmailConfig',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.EMAILCONFIG_EDIT_PATH,
        exact: true,
        component: EmailConfigEdit,
        isPublic: false,
        // controller: 'EmailConfig',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    // reports
    {
        path: URI_INTERNAL.LOGIN_HISTORY_PATH,
        exact: true,
        component: LoginHistory,
        isPublic: false,
        controller: 'LoginHistory',
        // controller: '',
        action: '',
        label: 'Lịch sử đăng nhập',
        menu: true,
        icon: 'fas fa-history',
        isPublic: false
    },
    {
        path: URI_INTERNAL.STATISTIC_HISTORY_PATH,
        exact: true,
        component: StatisticLoginHistory,
        isPublic: false,
        // controller: 'Report',
        controller: '',
        action: '',
        label: 'Thống kê lịch sử đăng nhập',
        menu: true,
        icon: 'fas fa-chart-pie',
        isPublic: false
    },
    // api-role-mapping
    {
        path: URI_INTERNAL.APIROLEMAPPING_PATH,
        exact: true,
        component: ApiRoleMapping,
        isPublic: false,
        controller: 'ApiRoleMapping',
        // controller: '',
        action: '',
        label: 'Phân quyền API',
        menu: true,
        icon: 'fas fa-key',
        isPublic: false
    },
    {
        path: URI_INTERNAL.APIROLEMAPPING_CREATE_PATH,
        exact: true,
        component: ApiRoleMappingAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.APIROLEMAPPING_EDIT_PATH,
        exact: true,
        component: ApiRoleMappingEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.OPENIDDICTAPPLICATION_PATH,
        exact: true,
        component: OpeniddictApplication,
        isPublic: false,
        controller: 'OpeniddictApplication',
        // controller: '',
        action: '',
        label: 'Ứng dụng đăng ký',
        menu: true,
        icon: 'fas fa-mobile-alt',
        isPublic: false
    },
    {
        path: URI_INTERNAL.OPENIDDICTAPPLICATION_CREATE_PATH,
        exact: true,
        component: OpeniddictApplicationAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.OPENIDDICTAPPLICATION_EDIT_PATH,
        exact: true,
        component: OpeniddictApplicationEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },
    // log
    {
        path: URI_INTERNAL.LOG_PATH,
        exact: true,
        component: Log,
        isPublic: false,
        controller: 'Log',
        // controller: '',
        action: '',
        label: 'Xem log',
        menu: true,
        icon: 'fas fa-list-alt',
        isPublic: false
    },
    // timeline
    {
        path: URI_INTERNAL.TIMELINE_PATH,
        exact: true,
        component: Timeline,
        isPublic: false,
        controller: 'AssetActivityLog',
        action: '',
        label: 'Timeline',
        menu: false,
        icon: 'fas fa-history',
        isPublic: false
    },
    {
        path: URI_INTERNAL.DEPARTMENT_PATH,
        exact: true,
        component: Department,
        isPublic: false,
        controller: 'Department',
        // controller: '',
        action: '',
        label: 'Đơn vị',
        menu: true,
        icon: 'fas fa-building',
        isPublic: false
    },
    {
        path: URI_INTERNAL.DEPARTMENT_CREATE_PATH,
        exact: true,
        component: DepartmentAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.DEPARTMENT_EDIT_PATH,
        exact: true,
        component: DepartmentEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.MATERIALCATALOG_PATH,
        exact: true,
        component: MaterialCatalog,
        isPublic: false,
        controller: 'MaterialCatalog',
        // controller: '',
        action: '',
        label: 'Vật tư / linh kiện',
        menu: true,
        icon: 'fas fa-box',
        isPublic: false
    },
    {
        path: URI_INTERNAL.MATERIALCATALOG_CREATE_PATH,
        exact: true,
        component: MaterialCatalogAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.MATERIALCATALOG_EDIT_PATH,
        exact: true,
        component: MaterialCatalogEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.MATERIALCATALOG_IMPORT_PATH,
        exact: true,
        component: MaterialCatalogBulkImport,
        isPublic: false,
        label: '',
        menu: false,
        isPublic: false
    },



    // {
    //   path: URI_INTERNAL.ASSETTRANSFER_CREATE_PATH,
    //   exact: true,
    //   component: AssetTransferAdd,
    //   isPublic: false,
    //   // controller: 'AssetTransfer',
    //   // action:     'Them',
    //   label: "",
    //   menu:       false,
    //   isPublic: false,
    // },
    // {
    //   path: URI_INTERNAL.ASSETTRANSFER_EDIT_PATH,
    //   exact: true,
    //   component: AssetTransferEdit,
    //   isPublic: false,
    //   // controller: 'AssetTransfer',
    //   // action:     'Sua',
    //   label: "",
    //   menu:       false,
    //   isPublic: false,
    // },

    // asset status
    {
        path: URI_INTERNAL.ASSETSTATUS_PATH,
        exact: true,
        component: AssetStatus,
        isPublic: false,
        controller: 'AssetStatus',
        // controller: '',
        action: '',
        label: 'Trạng thái tài sản',
        menu: true,
        icon: 'fas fa-info-circle',
        isPublic: false
    },
    {
        path: URI_INTERNAL.ASSETSTATUS_CREATE_PATH,
        exact: true,
        component: AssetStatusAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ASSETSTATUS_EDIT_PATH,
        exact: true,
        component: AssetStatusEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },
    // asset group
    {
        path: URI_INTERNAL.ASSETGROUP_PATH,
        exact: true,
        component: AssetGroup,
        isPublic: false,
        controller: 'AssetGroup',
        // controller: '',
        action: '',
        label: 'Nhóm tài sản',
        menu: true,
        icon: 'fas fa-layer-group',
        isPublic: false
    },
    {
        path: URI_INTERNAL.ASSETGROUP_CREATE_PATH,
        exact: true,
        component: AssetGroupAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ASSETGROUP_EDIT_PATH,
        exact: true,
        component: AssetGroupEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },
    // asset category
    {
        path: URI_INTERNAL.ASSET_CATEGORY_PATH,
        exact: true,
        component: AssetCategoryTabs,
        isPublic: false,
        controller: 'UsagePurpose',
        action: '',
        label: 'Danh mục bổ sung',
        menu: true,
        icon: 'fas fa-list-alt',
        isPublic: false
    },
    // asset
    {
        path: URI_INTERNAL.ASSET_PATH,
        exact: true,
        component: Asset,
        isPublic: false,
        controller: 'Asset',
        action: '',
        label: 'Tài sản',
        menu: true,
        icon: 'fas fa-desktop'
    },
    {
        path: URI_INTERNAL.ASSET_CREATE_PATH,
        exact: true,
        component: AssetAdd,
        isPublic: false,
        label: '',
        menu: false
    },
    {
        path: URI_INTERNAL.ASSET_EDIT_PATH,
        exact: true,
        component: AssetEdit,
        isPublic: false,
        label: '',
        menu: false
    },
    {
        path: URI_INTERNAL.ASSET_VIEW_PATH,
        exact: true,
        component: AssetPublicDetail,
        isPublic: false,
        label: '',
        menu: false
    },
    {
        path: URI_INTERNAL.ASSET_SCAN_PATH,
        exact: true,
        component: QRScanner,
        isPublic: false,
        label: 'Quét mã QR',
        menu: false
    },
    {
        path: URI_INTERNAL.ASSET_BULK_IMPORT_PATH,
        exact: true,
        component: AssetBulkImport,
        isPublic: false,
        controller: 'Asset',
        action: '',
        label: 'Nhập tài sản hàng loạt',
        menu: false
    },
    {
        path: URI_INTERNAL.ASSET_TRANSFER_PATH,
        exact: true,
        component: AssetTransfer,
        isPublic: false,
        label: '',
        menu: false
    },
    {
        path: URI_INTERNAL.ASSETTRANSFER_LIST_PATH,
        exact: true,
        component: AssetTransferList,
        isPublic: false,
        controller: 'AssetTransfer',
        // controller: '',
        action: '',
        label: 'Danh sách điều chuyển',
        menu: true,
        icon: 'fas fa-exchange-alt',
        isPublic: false
    },
    {
        path: URI_INTERNAL.MAINTENANCE_BATCH_PATH,
        exact: true,
        component: MaintenanceBatchList,
        isPublic: false,
        controller: 'AssetMaintenanceEvent',
        action: '',
        label: 'Phiếu sửa chữa',
        menu: true,
        icon: 'fas fa-tools',
        isPublic: false
    },
    {
        path: URI_INTERNAL.MAINTENANCE_BATCH_CREATE_PATH,
        exact: true,
        component: MaintenanceBatchAdd,
        isPublic: false,
        controller: 'AssetMaintenanceEvent',
        label: '',
        menu: false
    },
    {
        path: URI_INTERNAL.MAINTENANCE_BATCH_DETAIL_PATH,
        exact: true,
        component: MaintenanceBatchDetail,
        isPublic: false,
        controller: 'AssetMaintenanceEvent',
        label: '',
        menu: false
    },
    {
        path: URI_INTERNAL.INVENTORY_SESSION_PATH,
        exact: true,
        component: InventorySessionList,
        isPublic: false,
        controller: 'InventorySession',
        action: '',
        label: 'Kiểm kê tài sản',
        menu: true,
        icon: 'fas fa-clipboard-list',
    },
    {
        path: URI_INTERNAL.INVENTORY_SESSION_CREATE_PATH,
        exact: true,
        component: InventorySessionCreate,
        isPublic: false,
        controller: 'InventorySession',
        action: '',
        label: 'Tạo phiếu kiểm kê',
        menu: false,
    },
    {
        path: URI_INTERNAL.INVENTORY_SESSION_DETAIL_PATH,
        exact: true,
        component: InventorySessionDetail,
        isPublic: false,
        controller: 'InventorySession',
        action: '',
        label: 'Chi tiết phiếu kiểm kê',
        menu: false,
    },
    {
        path: URI_INTERNAL.ASSET_REPORT_PATH,
        exact: true,
        component: AssetReport,
        isPublic: false,
        controller: 'Asset', // Đặt cùng controller 'Asset' để vào nhóm Chức năng
        action: '',
        label: 'Báo cáo tài sản',
        menu: true,
        icon: 'fas fa-file-export',
    },
    {
        path: URI_INTERNAL.ASSET_DISPOSAL_PATH,
        exact: true,
        component: AssetDisposalList,
        isPublic: false,
        controller: 'AssetDisposal',
        action: '',
        label: 'Phiếu đào thải tài sản',
        menu: false,
        icon: 'fas fa-trash-alt',
    },
    {
        path: URI_INTERNAL.ASSET_DISPOSAL_CREATE_PATH,
        exact: true,
        component: AssetDisposalCreate,
        isPublic: false,
        controller: 'AssetDisposal',
        action: '',
        label: 'Tạo phiếu đào thải',
        menu: false,
    },
    { 
        path: URI_INTERNAL.ASSET_DISPOSAL_DETAIL_PATH,
        exact: true,
        component: AssetDisposalDetail,
        isPublic: false,
        controller: 'AssetDisposal',
        action: '',
        label: 'Chi tiết phiếu đào thải',
        menu: false,
    },
];

// function withController(routes) {
//   return routes.map(r => {
//     const name = r.component.displayName || r.component.name || '';
//     return {
//       ...r,
//       controller: r.controller ? r.controller : name,
//       // nếu chưa có label thì lấy tên component
//       label: r.label || name,
//     };
//   });
// }

function withController(routes) {
    return routes.map((r) => ({
        ...r,
        // controller: r.controller,
        label: r.label || r.controller
    }));
}

export const appRoutes = withController(rawRoutes);

export const menuGroups = [
    {
        title: 'Hệ thống',
        icon: 'fas fa-cog',
        // Lấy tất cả route menu thuộc nhóm Hệ thống
        children: appRoutes.filter(
            (r) =>
                r.menu &&
                [
                    'Account',
                    'Role',
                    'EmailConfig',
                    'ApiRoleMapping',
                    'OpeniddictApplication',
                    'Log',
                    'AssetActivityLog'
                ].includes(r.controller)
        )
    },
    {
        title: 'Danh mục',
        icon: 'fas fa-list',
        children: appRoutes.filter(
            (r) =>
                r.menu &&
                [
                    'Department',
                    'MaterialCatalog',
                    'AssetStatus',
                    'AssetGroup',
                    'UsagePurpose'
                ].includes(r.controller)
        )
    },
    {
        title: 'Chức năng',
        icon: 'fas fa-cog',
        children: appRoutes.filter(
            (r) =>
                r.menu &&
                [
                    'Asset',
                    'AssetTransfer',
                    'AssetMaintenanceEvent',
                    'InventorySession',
                    'AssetDisposal'
                ].includes(r.controller)
        )
    },
    {
        title: 'Báo cáo',
        icon: 'fas fa-table',
        // Lấy tất cả route menu thuộc nhóm Báo cáo
        children: appRoutes.filter(
            (r) =>
                r.menu &&
                ['LoginHistory', 'StatisticLoginHistory'].includes(r.controller)
        )
    }
];
